import React, { useState } from "react";
import { Navbar, Nav, Container, NavDropdown, Modal, Button } from 'react-bootstrap';
import { useHistory } from "react-router-dom";
import Image from "react-bootstrap/Image";
import "../navbar/navbar.css"
import { Link } from 'react-router-dom';
import { CgProfile } from "react-icons/cg";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa";

function NavbarComponent() {
  const history = useHistory();
  const [showCallModal, setShowCallModal] = useState(false);

  const handleShow = () => setShowCallModal(true);
  const handleClose = () => setShowCallModal(false);

  const Logout = () => {
    localStorage.clear();
    history.push("/");
    window.location.reload(true)
  };

  const handleNormalCall = () => {
    window.location.href = "tel:+94712129185";
  };

  const handleWhatsApp = () => {
    window.open("https://wa.me/94712129185", "_blank");
  };

  const callNowButton = (
    <button className="btn btn-light" onClick={handleShow}>
      Call Now
    </button>
  );

  if (localStorage.getItem("loginAccess") !== "true") {
    return (
      <>
        <Navbar expand="lg" className="navbar navbar-expand-lg navbar-custom">
          <Container className="justify-content-between">
            <Navbar.Brand href="/">
              <div id="home" className="web-view">
                <img
                  src="/logo color.jpg"
                  alt="CodeFlex"
                  style={{ width: '60px' }}
                  className="navbar-site-logo"
                />
                <span className="nav-site-name site-text-color">CodeFlex</span>
              </div>
              <div id="home" className="mobile-view">
                <img
                  src="/logo color.jpg"
                  alt="CodeFlex"
                  style={{ width: '60px' }}
                  className="navbar-mobile-site-logo"
                />
                <span className="nav-site-name site-text-color">CodeFlex</span>
              </div>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse className="collapse navbar-collapse">
              <ul className="navbar-nav ms-auto">
                <a className="nav-link site-text-color" aria-current="home" href="/">
                  Home
                </a>
                <a className="nav-link site-text-color" aria-current="about_us" href="/about_us">
                  About Us
                </a>
                <a className="nav-link site-text-color" aria-current="contact_us" href="/contact_us">
                  Contact Us
                </a>
                <li className="nav-item nav-left-li">
                  {callNowButton}
                </li>
              </ul>
            </Navbar.Collapse>
          </Container>
        </Navbar>
        <Modal show={showCallModal} onHide={handleClose} centered>
          <Modal.Body
            style={{
              textAlign: "center",
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "white",
              borderRadius: "6px",
              padding: "48px 32px",
              position: "relative",
              overflow: "hidden",
            }}
          >
            {/* Decorative circles */}
            <div
              style={{
                position: "absolute",
                top: "-50px",
                right: "-50px",
                width: "150px",
                height: "150px",
                borderRadius: "50%",
                background: "rgba(255, 255, 255, 0.1)",
              }}
            />
            <div
              style={{
                position: "absolute",
                bottom: "-30px",
                left: "-30px",
                width: "100px",
                height: "100px",
                borderRadius: "50%",
                background: "rgba(255, 255, 255, 0.08)",
              }}
            />

            {/* Content */}
            <div style={{ position: "relative", zIndex: 1 }}>
              {/* Icon */}
              <div
                style={{
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  background: "rgba(255, 255, 255, 0.2)",
                  backdropFilter: "blur(10px)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 24px",
                  fontSize: "32px",
                }}
              >
                📞
              </div>

              <h3 style={{ fontWeight: "700", marginBottom: "12px", fontSize: "28px" }}>
                Get In Touch
              </h3>
              <p
                style={{
                  marginBottom: "32px",
                  opacity: "0.95",
                  fontSize: "15px",
                  lineHeight: "1.6",
                }}
              >
                Choose your preferred way to connect with us
              </p>

              {/* Buttons */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                  maxWidth: "280px",
                  margin: "0 auto",
                }}
              >
                <Button
                  variant="light"
                  onClick={handleNormalCall}
                  style={{
                    borderRadius: "16px",
                    padding: "16px 24px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "12px",
                    fontWeight: "600",
                    fontSize: "16px",
                    border: "none",
                    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15)",
                    transition: "all 0.3s ease",
                    background: "white",
                    color: "#667eea",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow = "0 12px 32px rgba(0, 0, 0, 0.2)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "0 8px 24px rgba(0, 0, 0, 0.15)";
                  }}
                >
                  <FaPhoneAlt size={20} /> Phone Call
                </Button>

                <Button
                  variant="success"
                  onClick={handleWhatsApp}
                  style={{
                    borderRadius: "16px",
                    padding: "16px 24px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "12px",
                    fontWeight: "600",
                    fontSize: "16px",
                    border: "none",
                    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15)",
                    transition: "all 0.3s ease",
                    background: "#25D366",
                    color: "white",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow = "0 12px 32px rgba(0, 0, 0, 0.2)";
                    e.currentTarget.style.background = "#22c55e";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "0 8px 24px rgba(0, 0, 0, 0.15)";
                    e.currentTarget.style.background = "#25D366";
                  }}
                >
                  <FaWhatsapp size={22} /> WhatsApp
                </Button>
              </div>

              {/* Close hint */}
              <p
                style={{
                  marginTop: "24px",
                  fontSize: "13px",
                  opacity: "0.7",
                  cursor: "pointer",
                }}
                onClick={handleClose}
              >
                Press ESC to close
              </p>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  } else {
    return (
      <Navbar expand="lg" className="navbar navbar-expand-lg navbar-custom">
        <Container className="justify-content-between">
          <Navbar.Brand href="/">
            <div id="home" className="web-view">
              <img
                src="/logo color.jpg"
                alt="CodeFlex"
                style={{ width: '60px' }}
                className="navbar-site-logo"
              />
              <span className="nav-site-name site-text-color">CodeFlex</span>
            </div>
            <div id="home" className="mobile-view">
              <img
                src="/logo color.jpg"
                alt="CodeFlex"
                style={{ width: '60px' }}
                className="navbar-mobile-site-logo"
              />
              <span className="nav-site-name site-text-color">CodeFlex</span>
            </div>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse className="collapse navbar-collapse">
            <ul className="navbar-nav ms-auto">
              <Nav className="ml-auto">
                <a className="nav-link site-text-color" aria-current="home" href="/">
                  Home
                </a>
                <a className="nav-link site-text-color" aria-current="about_us" href="/about_us">
                  About Us
                </a>
                <a className="nav-link site-text-color" aria-current="contact_us" href="/contact_us">
                  Contact Us
                </a>
                <NavDropdown
                  title={
                    <span>
                      <CgProfile className="nav-user-profile-icon" />{' '}
                      {localStorage.getItem("fname")} {localStorage.getItem("lname")}
                    </span>
                  }

                >
                  <div className="nav-profile-dropdown">
                    <NavDropdown.Item className="nav-user-dropdown-item" href="#profile-settings">Profile Settings</NavDropdown.Item>
                    <NavDropdown.Item className="nav-user-dropdown-item" href="/my_ads">My Ads</NavDropdown.Item>
                    <NavDropdown.Item className="nav-user-dropdown-item" href="/my_favorite">My Favorites</NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item className="nav-user-dropdown-item" onClick={Logout}>Logout</NavDropdown.Item>
                  </div>
                </NavDropdown>
              </Nav>
            </ul>
          </Navbar.Collapse>
        </Container>
      </Navbar >
    );
  }
};

export default NavbarComponent;
